import { Box } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import PurpleLockSvg from "@common/svgs/purpleLock.svg?react";

interface EntityTemplateOptionProps {
    name: string;
    lockedText?: string;
}

// The select only places its own option hover text below the option, so a locked option draws its tooltip itself.
// A disabled option ignores the pointer, so the hover area opts back in and keeps its clicks from selecting it.
function EntityTemplateOption(props: EntityTemplateOptionProps) {
    if (!props.lockedText) {
        return <span>{props.name}</span>;
    }

    return (
        <DotLegalTooltip text={props.lockedText} position="left">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexGrow: 1, pointerEvents: "auto" }} onClick={(event) => event.stopPropagation()}>
                <span>{props.name}</span>
                <PurpleLockSvg />
            </Box>
        </DotLegalTooltip>
    );
}

export default EntityTemplateOption;
